import { render, staticRenderFns } from "./ongoing-course-work.vue?vue&type=template&id=276faf36&scoped=true"
import script from "./ongoing-course-work.vue?vue&type=script&setup=true&lang=ts"
export * from "./ongoing-course-work.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ongoing-course-work.vue?vue&type=style&index=0&id=276faf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276faf36",
  null
  
)

export default component.exports